// src/pages/Admin.jsx
import { useEffect } from "react";

const Admin = () => {
  useEffect(() => {
    window.location.href = "https://swami-g-mission.vercel.app";
  }, []);

  return null; // nothing to render, just redirect
};

export default Admin;
